import "core-js/modules/es.function.name.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0f480e5a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "admin-menu"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "首页", -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "归档", -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "分类", -1);
});

var _hoisted_5 = /*#__PURE__*/_createTextVNode("🗂️ ");

var _hoisted_6 = {
  class: "link-name"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "标签", -1);
});

var _hoisted_8 = /*#__PURE__*/_createTextVNode("🔖 ");

var _hoisted_9 = {
  class: "link-name"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "新随笔", -1);
});

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "个人中心", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_kila_kila_admin_card = _resolveComponent("kila-kila-admin-card");

  var _component_kila_kila_divider = _resolveComponent("kila-kila-divider");

  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");

  var _component_el_menu_item = _resolveComponent("el-menu-item");

  var _component_el_sub_menu = _resolveComponent("el-sub-menu");

  var _component_el_menu = _resolveComponent("el-menu");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_kila_kila_admin_card), _createVNode(_component_kila_kila_divider), _createVNode(_component_el_menu, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_menu_item, {
        index: "1",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.$router.push('/');
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_font_awesome_icon, {
            icon: ['fab', 'fort-awesome'],
            class: "menu-icon"
          }), _hoisted_2];
        }),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "2",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.$router.push('/archive');
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'box-archive'],
            class: "menu-icon"
          }), _hoisted_3];
        }),
        _: 1
      }), _createVNode(_component_el_sub_menu, {
        index: "3"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'folder'],
            class: "menu-icon"
          }), _hoisted_4];
        }),
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.categoryAbout.categoryCounts, function (category) {
            return _openBlock(), _createBlock(_component_el_menu_item, {
              key: category.id,
              index: '3-' + category.id,
              class: "link-item",
              onClick: function onClick($event) {
                return _ctx.$router.push('/category/' + category.id);
              }
            }, {
              default: _withCtx(function () {
                return [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(category.name), 1), _createElementVNode("span", null, _toDisplayString(category.count), 1)];
              }),
              _: 2
            }, 1032, ["index", "onClick"]);
          }), 128))];
        }),
        _: 1
      }), _createVNode(_component_el_sub_menu, {
        index: "4"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'tags'],
            class: "menu-icon"
          }), _hoisted_7];
        }),
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.tagAbout.tagCounts, function (tag) {
            return _openBlock(), _createBlock(_component_el_menu_item, {
              key: tag.id,
              index: '4-' + tag.id,
              class: "link-item",
              onClick: function onClick($event) {
                return _ctx.$router.push('/tag/' + tag.id);
              }
            }, {
              default: _withCtx(function () {
                return [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(tag.name), 1), _createElementVNode("span", null, _toDisplayString(tag.count), 1)];
              }),
              _: 2
            }, 1032, ["index", "onClick"]);
          }), 128))];
        }),
        _: 1
      }), _ctx.$store.state.adminAbout.isAdmin ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: "5",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.$router.push('/article/add');
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'pen'],
            class: "menu-icon"
          }), _hoisted_10];
        }),
        _: 1
      })) : _createCommentVNode("", true), _ctx.$store.state.adminAbout.isAdmin ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: "6",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.$router.push('/user/settings');
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'user'],
            class: "menu-icon"
          }), _hoisted_11];
        }),
        _: 1
      })) : _createCommentVNode("", true)];
    }),
    _: 1
  })]);
}